import type { SVGProps } from 'react';

const SvgChevronSmallIsolatedN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 15.022c-.26 0-.51-.1-.71-.29L12 11.442l-3.29 3.29a.996.996 0 1 1-1.41-1.41l4-4a.996.996 0 0 1 1.41 0l4 4a.996.996 0 0 1-.71 1.7"
    />
  </svg>
);
export default SvgChevronSmallIsolatedN;
